import produce from 'immer';
import values from 'lodash/values';
import { BasketItem, BasketMessage, Surcharge } from '../types';

export default produce<State,any>((draft, action) => {
    switch (action.type) {
        case 'toggleOpen':
            draft.isOpen = !draft.isOpen;
            break;
        case 'close':
            draft.isOpen = false;
            break;
        case 'addingItem':
            draft.isOpen = true;
            draft.isProcessing = true;
            draft.basketItems.unshift(action.basketItem);
            break;
        case 'addingManyItems':
            draft.isOpen = true;
            draft.isProcessing = true;
            draft.basketItems = draft.basketItems.concat(action.basketItems);
            break;
        case 'changingItemQuantity':
            draft.isProcessing = true;
            break;
        case 'removingItem':
            draft.isProcessing = true;
            draft.basketItems = draft.basketItems.filter(bi => bi.sku !== action.basketItem.sku);
            break;
        case 'changingOrderType':
            draft.isProcessing = true;
            break;
        case 'addedItem':
        case 'changedItemQuantity':
        case 'removedItem':
        case 'changedOrderType':
            draft.isProcessing = false;
            draft.basketItems = values(action.basket.items);
            draft.surcharges = action.basket.surcharges;
            draft.errors = action.basket.errors;
            draft.subtotal = action.basket.subtotal;
            draft.subtotalExcludingDelivery = action.basket.subtotal_excluding_delivery;
            draft.subtotalExcludingSurcharges = action.basket.subtotal_excluding_surcharges;
            draft.tax = action.basket.tax;
            draft.taxExcludingDelivery = action.basket.tax_excluding_delivery;
            draft.total = action.basket.total;
            draft.orderType = action.basket.order_type ?? null;
            draft.deliveryOption = action.basket.delivery_option;
            draft.deliveryPrice = action.basket.delivery_price;
            draft.deliveryTax = action.basket.delivery_tax;
            draft.freeDelivery = (action.basket.free_delivery_eligible) ? null : action.basket.amount_until_free_delivery;
            break;
        case 'updateMessages':
            draft.errorMessage = action.error;
            draft.warningMessage = action.warning;
            draft.successMessage = action.success;
            break;
        case 'error':
            draft.isProcessing = false;
            break;
    }
});

export interface State {
    basketItems: Array<BasketItem>;
    errors: Array<BasketMessage>;
    surcharges: Array<Surcharge>;
    subtotal: string;
    subtotalExcludingSurcharges: string;
    subtotalExcludingDelivery: string;
    tax: string;
    taxExcludingDelivery: string;
    total: string;
    orderType: string | null;
    deliveryOption: number | null;
    deliveryPrice: string | null;
    deliveryTax: string | null;
    freeDelivery: string | null;
    isOpen: boolean;
    isProcessing: boolean;
    errorMessage: string;
    warningMessage: string;
    successMessage: string;
}
